import React from 'react';
import * as S from './styled';
export const Add = () => /*#__PURE__*/React.createElement(S.Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-label": "toevoegen",
  viewBox: "0 0 64 64"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("polygon", {
  fill: "currentColor",
  points: "30 30 11 30 11 34 30 34 30 52 34 52 34 34 53 34 53 30 34 30 34 12 30 12"
})));